<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30.547"
    height="29.534"
    viewBox="0 0 30.547 29.534"
  >
    <g id="Group_55" data-name="Group 55">
      <path
        id="Path_67"
        data-name="Path 67"
        d="M263.45,281.64l-2.075-2.3-2.3,2.075a.632.632,0,1,0,.847.939l.741-.668a11.1,11.1,0,0,1-12.142,9.435.632.632,0,1,0-.133,1.257,12.339,12.339,0,0,0,13.532-10.545l.591.655a.632.632,0,1,0,.939-.847Z"
        transform="translate(-233.066 -263.096)"
        class="svg-primary"
      />
      <path
        id="Path_68"
        data-name="Path 68"
        d="M268.488,53.223v.632h13.281v-.632a6.652,6.652,0,0,0-4.919-6.414,3.857,3.857,0,1,0-3.442,0A6.652,6.652,0,0,0,268.488,53.223Z"
        transform="translate(-252.425 -38.424)"
        class="svg-primary"
      />
      <path
        id="Path_69"
        data-name="Path 69"
        d="M57.885,25.065,55.861,22.72a.632.632,0,1,0-.957.827l.544.63a12.364,12.364,0,0,0-13.2,11.146.633.633,0,0,0,.57.69c.02,0,.04,0,.061,0a.633.633,0,0,0,.629-.572,11.1,11.1,0,0,1,12-9.992l-.79.682a.632.632,0,0,0,.827.957Z"
        transform="translate(-40.488 -22.501)"
        class="svg-primary"
      />
      <path
        id="Path_70"
        data-name="Path 70"
        d="M22.849,269.809a3.857,3.857,0,1,0-3.442,0,6.652,6.652,0,0,0-4.919,6.414v.632H27.769v-.632A6.652,6.652,0,0,0,22.849,269.809Z"
        transform="translate(-14.488 -247.321)"
        class="svg-primary"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
